import { MouseEvent, TouchEvent, useState, useEffect } from "react";

function useLongPress(
    timeoutTimeMS: number,
    longPressCallback?: (e?: MouseEvent) => void,
    shortPressCallback?: (e?: MouseEvent) => void
): [
    mouseCallbacks: {
        onMouseDown: (e: MouseEvent) => void;
        onMouseUp: (e: MouseEvent) => void;
        onMouseLeave: (e: MouseEvent) => void;
        onTouchStart: (e: TouchEvent) => void;
        onTouchEnd: (e: TouchEvent) => void;
    },
    isPressing: boolean,
    isPressComplete: boolean
] {
    const [isPressing, setIsPressing] = useState<boolean>(false);
    const [pressTimeoutComplete, setPressTimeoutComplete] =
        useState<boolean>(false);

    useEffect(() => {
        let timeoutID: NodeJS.Timeout | undefined;

        if (isPressing) {
            timeoutID = setTimeout(() => {
                setPressTimeoutComplete(true);
            }, timeoutTimeMS);
        } else {
            clearTimeout(timeoutID);
        }

        return () => {
            if (timeoutID != null) {
                clearTimeout(timeoutID);
            }
        };
    }, [longPressCallback, timeoutTimeMS, isPressing]);

    return [
        {
            onMouseDown: (e: React.MouseEvent) => {
                setIsPressing(true);
                setPressTimeoutComplete(false);
            },
            onMouseUp: (e) => {
                if (longPressCallback != null && pressTimeoutComplete) {
                    longPressCallback(e);
                } else if (shortPressCallback != null) {
                    shortPressCallback(e);
                }
                setIsPressing(false);
                setPressTimeoutComplete(false);
            },
            onMouseLeave: () => {
                setIsPressing(false);
                setPressTimeoutComplete(false);
            },
            onTouchStart: () => {
                setIsPressing(true);
                setPressTimeoutComplete(false);
            },
            onTouchEnd: (e) => {
                if (longPressCallback != null && pressTimeoutComplete) {
                    longPressCallback();
                } else if (shortPressCallback != null) {
                    // shortPressCallback();
                }
                setIsPressing(false);
                setPressTimeoutComplete(false);
            },
        },
        isPressing,
        pressTimeoutComplete,
    ];
}

export { useLongPress };
